<template>
  <div class="content">
    <div class="logo">
      <div class="fechar" title="Fechar Menu">
        <router-link to="/">
          <i class="fas fa-times icone-svg" title="Fechar Menu"></i>
        </router-link>
      </div>
      <router-link to="/">
        <img src="https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Flogo.webp?alt=media&token=e0c2d07f-8025-43ab-9ec6-40da8496bf16" alt="Ilha do Caranguejo" />
      </router-link>
      <div class="icones">
        <a href="https://pt-br.facebook.com/ilhadocaranguejo/" target="_blank" title="Facebook Ilha do Caranguejo">
          <i class="fab fa-facebook-square icone-svg"></i>
        </a>
        <a href="https://www.instagram.com/ilhadocaranguejo/?hl=pt-br" target="_blank" title="Instagram Ilha do Caranguejo">
          <i class="fab fa-instagram-square icone-svg"></i>
        </a>
      </div>
      <!--
      <div class="form">
        <input type="titulo" name="titulo" placeholder=""><i class="fas fa-search icone-svg2"></i>
      </div>
      -->
      <div class="telefones">
        <p>
          VITÓRIA (27) 3395-0244<br>
          VILA VELHA (27) 2233-8484<br>
        </p>
      </div>
    </div>

    <div class="menu">
      <span>
        <router-link v-if="$store.state.usuario.usuario != null" to="/minhaconta">ACESSE SUA CONTA</router-link>
        <router-link v-if="$store.state.usuario.usuario == null" to="/login">LOGIN / CADASTRE-SE</router-link>
      </span>
      <span>
        <a href="http://www.ilhadocaranguejo.com" target="_blank" title="Cardápio Ilha do Caranguejo">
          CARDÁPIO
        </a>
      </span>
      <span v-for="documento in documentos" :key="documento.id">
        <router-link :to="'pagina/' + documento.id">{{documento.Titulo.toUpperCase()}}</router-link>
      </span>
    </div>

    <div class="foto">
      <div class="fechar2" title="Fechar Menu">
        <router-link to="/">
          <i class="fas fa-times icone-svg" title="Fechar Menu"></i>
        </router-link>
      </div>
      <div class="fundo-laranja"></div>
      <div class="outer-div">
        <div class="inner-div"></div>
      </div>
      <span class="legenda">Unidade Vitória - Jd Camburi</span>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase.js'
import VueScreenSize from 'vue-screen-size'

export default {
  name: 'Menu',
  components: {
    db
  },
  data () {
    return {
      documentos: {}
    }
  },
  firestore: {
    documentos: db.collection('Paginas').orderBy('Titulo', 'asc')
  },
  mixins: [VueScreenSize.VueScreenSizeMixin]
}
</script>

<style scoped>
.content {
  text-align: center;
  background: #fff;
  width: 100%;
  height: 100%;
  z-index: 998;
  position: fixed;
  top: 0;
  left: 0;
  transition: all 0.5s;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "logo menu foto"
}

.icone-svg {
  width: 30px;
  height: 30px;
}

.icone-svg2 {
  width: 25px;
  height: 25px;
  margin: 0 0 0 -40px;
  padding: 5px 0 0 0;
}

.logo {
  grid-area: logo;
  margin: 5% 20% 10% 20%;
  justify-content: center;
}

.logo img {
  margin: 0 auto 15px auto;
  max-width: 160px;
}

.telefones {
  font-size: 1em;
  color: #F85E28;
  padding: 12px 0;
  line-height: 2;
}

.fechar2 {
  display: none;
}

.fechar, .fechar2 {
  margin: 0 0 80% 0;
  cursor: pointer;
  text-align: left;
}

.fechar a, .fechar2 a {
  color: #F85E28;
}

.fechar a:hover, .fechar2 a:hover  {
  color: #E1331B;
}

.icones a {
  margin: 20px 6px 0 6px;
  color: #F85E28;
}

.icones a:hover {
  color: #E1331B;
}

.form {
  margin: 20px 0;
  color: #F85E28;
}

input {
  border: 1px solid #F85E28;
  background: #fff;
  width: 60%;
  margin: 0 10px 0 0;
}

.menu {
  grid-area: menu;
  margin: 60% 20% 30% 0;
  padding: 0 10% 0 10%;
  display: grid;
  align-content: start;
  justify-items: start;
}

.menu span {
  font-size: 1.3em;
  font-weight: 700;
  display: block;
  padding: 20px 0 0 0;
  cursor: pointer;
  transition: all 0.5s;
}

.menu span a{
  color: #F85E28;
}

.menu span a:hover {
  color: #E1331B;
  text-decoration: underline;
}

.foto {
  grid-area: foto;
  margin: 0 0 0 -50px;
}

.fundo-laranja {
  width: 410px;
  height: 482px;
  background: #F85E28;
  position: relative;
  z-index: 1;
  top: 0px;
  left: 0px
}

.foto-menu {
  position: relative;
  left: 50px;
  top: -482px;
  z-index: 2;
}

.outer-div {
  position: relative;
  left: 50px;
  top: -482px;
  z-index: 2;
  width: 462px;
  height: 436px;
  overflow: hidden;
  margin: 0;
}

.inner-div {
  height: 100%;
  width: 100%;
  
  background-image: url("https://firebasestorage.googleapis.com/v0/b/loja-ilha-teste.appspot.com/o/assets%2Ffoto_menu_vix.webp?alt=media&token=5a0b43aa-4bba-4d9d-ab71-d6203f1afdf2");
  background-size: cover;
  background-position: center;
  transition: all 0.7s ease;
}

.inner-div:hover {
  transform: scale(1.1);
}

.legenda {
  display: block;
  color: #fff;
  text-align: left;
  font-size: 0.9em;
  padding: 5px 0 0 0;
  position: relative;
  left: 50px;
  top: -482px;
  z-index: 10;
}

@media (max-width: 1260px) {
  .logo {
    margin: 5% 10% 10% 10%;
  }
  .menu {
    margin: 60% 10% 30% 0;
    padding: 0 1% 0 1%;
  }
  .foto {
    margin: 0 0 0 -30px;
  }
}

@media (max-width: 960px) {
  .logo {
    margin: 5% 1% 10% 1%;
  }
  .menu {
    margin: 60% 2% 30% 0;
    padding: 0 1% 0 1%;
  }
  .foto {
    margin: 0 0 0 0;
  }
}

@media (max-width: 900px) {
  .content {
    grid-template-columns: 1fr;
    grid-template-areas:
      "foto"
      "logo"
      "menu"
  }
  .logo {
    position: relative;
    margin: 0;
    top: -60px;
    z-index: 5;
  }
  .telefones {
    display: none;
  }
  .fechar {
    margin: 0;
    display: none;
  }
  .fechar2 {
    display: block;
    margin: 10px 15px;
  }
  .foto {
    margin: 0;
  }
  .outer-div {
    position: relative;
    left: 0;
    top: 0;
    z-index: 1;
    width: 90%;
    height: 180px;
    overflow: hidden;
    margin: 0 auto;
  }
  .fundo-laranja {
    display: none;
  }
  .legenda {
    display: none;
  }
  .menu {
    position: relative;
    margin: 0;
    top: -50px;
    padding: 0 5% 0 5%;
    justify-items: center;
  }
  .menu span {
    font-size: 1.1em;
    font-weight: 600;
    padding: 0 0 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Menu.vue